import {
  Switch,
  useHistory,
  Route,
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import Mint from "./components/Mint";
import { StateProvider } from "./StateProvider.js";
import { reducer, initialState } from "./reducer.js";

function App() {
  const history = useHistory();
  return (
    <div className="app">
      <StateProvider initialState={initialState} reducer={reducer}>
        {/* <Router basename={"/"} history= {history}> */}
        <Router basename={"/"} history={history}>
          <Switch>
            <Route
              exact
              path="/"
              render={() => {
                return <Redirect to="/home" />;
              }}
            />
            <Route path="/home" exact component={Home} />
            <Route path="/mint" exact component={Mint} />
          </Switch>
        </Router>
      </StateProvider>
    </div>
  );
}

export default App;
